module.exports = __webpack_public_path__ + "static/media/sweet_view_9.42b5f3a5.jpg";